import actions from '../../actionTypes';

export default categories => {
  return {
    type: actions.SET_CATEGORIES,
    categories
  };
};



// WEBPACK FOOTER //
// ./src/reducers/categories/actions/setCategories.js